import React from 'react'
import { Button, Card, Container, Icon, Image, Flag, Sticky, Header } from 'semantic-ui-react'

import profilePicture from './../images/profilePicture2.png';
import * as ES_CV from './../docs/CV_LuisBoscan_ES.pdf';
import * as EN_CV from './../docs/CV_LuisBoscan_EN_v2.pdf';

const SideCard = (props) => (
  <Sticky offset={10} context={props.contextRef}>
    <Container className="side-card">
      <Card>
        <Image src={profilePicture} />
        <Card.Content>
          <Card.Header>Luis Felipe Boscan Nava</Card.Header>
        </Card.Content>
        <Card.Content>
          <div>
            <Icon name='desktop' /> System Engineer
        </div>
          <div>
            <Icon name='laptop' /> Full Stack Developer
        </div>
          <div style={{ borderBottom: '1px solid rgba(34,36,38,.1)', marginBottom: 5, marginTop: 5 }}></div>
          <div>
            <Flag name="ve" /> Venezuelan
        </div>
          <div>
            <Flag name="cl" /> Living in Santiago de Chile
        </div>
        </Card.Content>
        <Card.Content>
          <Container className="social-icons" textAlign="center" fluid>
            <Button as="a" href="https://github.com/lfbos" target="_blank" circular color='black' icon='github' />
            <Button as="a" href="https://www.linkedin.com/in/lfboscan/" target="_blank" circular color='linkedin' icon='linkedin' />
            <Button as="a" href="https://plus.google.com/+LuisBoscan19" target="_blank" circular color='google plus' icon='google plus' />
          </Container>
        </Card.Content>
        <Card.Content>
        <Container fluid textAlign="center">
          <Header as="h4">DOWNLOAD CV</Header>
          <Button.Group>
            <Button 
              basic color="blue"
              as="a" 
              href={EN_CV} 
              download="CV_LuisBoscan_EN">
              <Flag name="us" /> EN
            </Button>
            <Button.Or />
            <Button 
              basic color="red"
              as="a" 
              href={ES_CV} 
              download="CV_LuisBoscan_ES">
              <Flag name="es" /> ES
            </Button>
          </Button.Group>
        </Container>
        </Card.Content>
      </Card>
    </Container>
  </Sticky>
)

export default SideCard;



// WEBPACK FOOTER //
// ./src/components/SideCard.js